import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
import type { LeaderboardMetricScore } from '@/sections/customerManagement/types';

interface Props {
  metric: LeaderboardMetricScore | undefined;
  label: string;
  colorClass?: string;
}

export function MetricCell({ metric, label, colorClass }: Props) {
  if (!metric || metric.rawValue === 0) {
    return <span className="text-chariot-text-secondary text-sm">—</span>;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={cn(
              'cursor-default text-sm font-medium',
              colorClass ?? 'text-chariot-text-primary'
            )}
          >
            {metric.score.toFixed(1)}
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <div className="space-y-1 text-xs">
            <p className="font-medium">{label}</p>
            <p>Raw: {metric.rawValue}</p>
            <p>Weight: {metric.weight}</p>
            <p>Score: {metric.score.toFixed(2)}</p>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
